export const FORM_SEARCH = ({ userList }) => {
  return [
    {
      name: 'search',
      label: 'รหัส/ชื่อพนักงาน',
      type: 'DROPDOWN',
      properties: {
        options: userList || [],
      },
      rules: {
        required: true,
      },
      span: 8,
    },
  ];
};

export const FORM_ADD_PERMISSION = ({ userList, userTypeList }) => {
  return [
    {
      name: 'userId',
      label: 'รหัส/ชื่อพนักงาน',
      type: 'DROPDOWN',
      properties: {
        options: userList || [],
      },
      rules: {
        required: true,
      },
      span: 24,
    },
    {
      name: 'userTypeId',
      label: 'สิทธิ์',
      type: 'DROPDOWN',
      properties: {
        options: userTypeList || [],
      },
      rules: {
        required: true,
      },
      span: 24,
    },
  ];
};


export const searchDefaultValue = {
  search: '',
};
